// ##### 24-06-12 Komarov
import parse from 'html-react-parser';
import uniqueId from 'lodash.uniqueid';
// ##### Komarov 2025-08-27
import React, { useCallback } from 'react';
import { Media } from '../../../../../helpers/MediaConfig';
import { useMessagesObj } from '../../../../../helpers/messages';
// ##### 25-05-21 Komarov
import LogInLinkTag from '../../../../Library/Common/LogInLinkTag';
import LangSelectionTool from '../../../../Library/Localization/LangSelectionTool/LangSelectionTool';
import LocalizationNavLink from '../../../../Library/Localization/LocalizationNavLink';
import CurrencySelectionTool from '../../CurrencySelectionTool/CurrencySelectionTool';
import LargeScreensNavBar from '../LargeScreensNavBar';
import SmallScreensNavBar from '../SmallScreensNavBar';
import HeaderH2 from './HeaderH2';
// ##### Komarov 2025-08-27
import { useSelector, useDispatch } from 'react-redux';
import { useLocalizedText } from '../../../../../hooks/useLocalizedText.js';
// ##### 25-04-24 Komarov
import { unsetDevMode } from '../../../../../Redux/actions';
// ##### Komarov 2025-07-21
import { withSmartDataId } from '../../../../../Redux/helpers/withSmartDataId';

// ##### Komarov 2025-07-22
const MiddleMenuDiv = ({ className, logoWidth = 'unset' }) => {
  const sitePagesObj = useMessagesObj();
  const pages = useSelector(state => state.pages.pages);
  // ##### Komarov 2025-08-05
  const Home_icon = useLocalizedText('Home_icon');
  // ##### Komarov 2025-08-27
  const devMode = useSelector(state => state.devMode);

  const dispatch = useDispatch();
  const handleOutDev = useCallback(() => {
    localStorage.removeItem('devKey');
    // ##### Komarov 2025-08-26
    // Удаляем cookie devMode
    document.cookie = 'devMode=; Path=/; Max-Age=0';
    dispatch(unsetDevMode());
  }, [dispatch]);

  return (
    <div className={className} data-component="MiddleMenuDiv">
      <div style={{ width: logoWidth }}>
        {/* ##### 23-08-29 Komarov */}
        <LocalizationNavLink
          exact
          // ##### 24-03-21 Komarov
          to={''}
          hintIsPresent
          hintText={parse(Home_icon)}
        >
          {/* ##### 23-11-01 Komarov */}
          <Media greaterThanOrEqual="Laptop-1024-1440">
            <img
              className="ArkturDMClogo"
              // ##### Komarov 2025-07-25
              src="/images/ArkturDMClogo.svg"
              alt="Arktur DMC logo"
            />
          </Media>
          <Media lessThan="Laptop-1024-1440">
            {/* <img
            className='ArkturDMClogoSmall for-portrait-screen'
            src={ArkturDMClogo}
            alt='Arktur DMC logo'
          /> */}
            <img
              // className='ArkturDMClogoSmall for-landscape-screen'
              className="ArkturDMClogoSmall"
              // ##### Komarov 2025-07-25
              src="/images/ArkturDMClogo.svg"
              alt="Arktur DMC logo"
            />
          </Media>
        </LocalizationNavLink>
      </div>

      <Media greaterThanOrEqual="Laptop-1024-1440">
        <div style={{ margin: 'auto' }}>
          {/* ##### 24-08-10 Komarov */}
          <HeaderH2 className="ArkturSloganBig" fontSize="22px" />
        </div>
      </Media>
      <Media between={['Tablet-768-1024', 'Laptop-1024-1440']}>
        <HeaderH2
          className="ArkturSloganSmall"
          // ##### 23-11-02 Komarov
          // fontSize='5vh'
          fontSize="1.7em"
        />
      </Media>
      <Media at="Mobile-L-425-768">
        <HeaderH2
          className="ArkturSloganSmall"
          // ##### 23-11-02 Komarov
          // fontSize='3vh'
          fontSize="1.1em"
        />
      </Media>
      <Media lessThan="Mobile-L-425-768">
        <HeaderH2
          className="ArkturSloganSmall"
          // ##### 23-11-02 Komarov
          // fontSize='2.5vh'
          fontSize="0.8em"
        />
      </Media>
      <>
        {/* ##### 23-11-01 Komarov */}
        <Media greaterThanOrEqual="Laptop-1024-1440">
          {/* ##### 24-06-20 Komarov */}
          {sitePagesObj.Header.MIDDLE && (
            <LargeScreensNavBar
              // pages={pages.pages}
              sitepage_type={sitePagesObj.Header.MIDDLE}
              linkClassName="nav_big_link"
              key={() => uniqueId()}
            />
          )}
        </Media>
        { /* ##### Komarov 2025-08-26 */}
        <Media lessThan="Laptop-1024-1440">
          {/* ##### Komarov 2025-08-27: кнопка для выхода из режима Разработчика */}
          {devMode && (
            <button
              onClick={handleOutDev}
              style={{
                marginLeft: '10px',
                padding: '4px 8px',
                backgroundColor: '#ff4444',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '12px',
                fontWeight: 'bold',
              }}
            >
              outDev
            </button>
          )}
        </Media>
        <Media lessThan="Laptop-1024-1440">
          {/* ##### 23-04-05 Komarov */}
          <LogInLinkTag right={null} onSmallScreen={true} />
        </Media>
        {/* ##### 23-11-01 Komarov */}
        <Media lessThan="Laptop-1024-1440">
          {/* ##### 24-06-20 Komarov */}
          <React.Fragment key={() => uniqueId()}>
            {/* ##### 23-11-01 Komarov */}
            {sitePagesObj.Header.UPPER && (
              <>
                <Media greaterThanOrEqual="Mobile-L-425-768">
                  <SmallScreensNavBar
                    navClass="nav-small"
                    linkClassName="nav-small-link-mobile-landscape"
                    pages={pages}
                    sitepage_type={sitePagesObj.Header.UPPER}
                    key={() => uniqueId()}
                  />
                </Media>
                <Media lessThan="Mobile-L-425-768">
                  <SmallScreensNavBar
                    navClass="nav-small"
                    linkClassName="nav-small-link"
                    pages={pages}
                    sitepage_type={sitePagesObj.Header.UPPER}
                    key={() => uniqueId()}
                  />
                </Media>
              </>
            )}
          </React.Fragment>
        </Media>
        {/* ##### 23-04-11 Komarov - end */}
      </>

      {/* ##### 25-01-16 Komarov */}
      <Media
        greaterThanOrEqual="Laptop-1024-1440"
        style={{
          marginTop: 'auto',
          marginBottom: 'auto',
        }}
      >
        <div className="LangCurrency">
          {/* TODO: Сделать html-разметку select-list'а с соотв. опциями (пунктами) */}
          {/* ##### 23-04-07 Komarov */}
          <CurrencySelectionTool />
          {/* TODO: Сделать html-разметку select-list'а с соотв. опциями (пунктами) */}
          <LangSelectionTool />
        </div>
      </Media>
    </div>
  );
};

export default withSmartDataId('GET_PAGES_RES')(MiddleMenuDiv);
